import React from 'react';
import { propOr } from 'ramda';
import { DynamicParametersRefresher } from 'context/DynamicParameters/DynamicParametersRefresher';
import { DynamicParametersProvider } from 'context/DynamicParameters/DynamicParametersContext';

const withDynamicParameters = (WrappedComponent: React.FC) => {
  const wrappedDisplayName = propOr(propOr('Component', 'name', WrappedComponent), 'displayName', WrappedComponent);

  const WithDynamicParameters = (props: { [key: string]: any }) => (
    <DynamicParametersProvider>
      <WrappedComponent {...props} />
      <DynamicParametersRefresher />
    </DynamicParametersProvider>
  );
  WithDynamicParameters.displayName = `withDynamicParameters(${wrappedDisplayName})`;

  return WithDynamicParameters;
};

export default withDynamicParameters;
